import React, { useState, createRef, useEffect } from 'react';

import './Input.scss';
import {InputLog} from "../../services/interactions/elements/input";


function Input({ placeholder, label, value, onChange, onBlur, onClick, type, min, max, disabled, required, error, errorMessage, prefix, regexTest }) {
    const [isFocused, setIsFocused] = useState(false);
    const inputRef = createRef();
    const [prefixHeight, setPrefixHeight] = useState(0);
    if (type === 'password') {
        throw new Error('Password type should be used with InputPassword component instead');
    }
    if (type === 'file') {
        throw new Error('File type should be used with InputFile component instead');
    }
    const _onBlur = (e) => {
        setIsFocused(false);
        if(!!onBlur){
            onBlur();
        }
        _onChange(e);
    }
    const onFocus = () => {
        setIsFocused(true);
    }
    const _onClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    }
    const _onChange = (e) => {
        if (type === 'number') {
            onChange(parseFloat(e.target.value));
        } else {
            onChange(e.target.value);
        }
    }
    useEffect(() => {
        if (prefix) {
            if (!!inputRef && inputRef.current.getBoundingClientRect() && !prefixHeight) {
                const boundingClient = inputRef.current.getBoundingClientRect();
                // -2 to consider border
                setPrefixHeight(boundingClient.height - 2);
            }
        }
    }, [inputRef, prefixHeight, prefix]);
    const regexError = !value || !regexTest? true : regexTest.test(value);
    return (
        <div className={`InputComponent ${isFocused ? 'focused' : ''} ${prefix ? 'prefix' : ''} ${(!!value || isFocused) ? 'dirty' : ''} ${error || !regexError? 'error' : ''}`}>
            {
                label ?
                    <label>
                        {label}{required ? <span className="__req">*</span> : ''}
                    </label>
                    : ''
            }
            {
                error && errorMessage?
                    <label className="error">{errorMessage}</label> : ''
            }
            <div className="_inputContain">
                {
                    prefix && prefixHeight ?
                        <div className="_prefix" style={{ height: `${prefixHeight}px` }}>
                            <p>{prefix}</p>
                        </div>
                        : ''
                }

                <input
                    ref={inputRef}
                    value={value}
                    type={type}
                    onClick={_onClick}
                    onBlur={_onBlur}
                    onFocus={onFocus}
                    onChange={_onChange}
                    min={min || null}
                    max={max || null}
                    disabled={disabled || false}
                    placeholder={placeholder}
                />
            </div>
        </div>
    )
}

export default InputLog(Input);
